export default class C2DRenderer{
    constructor({engine}) {
        this.outCanvas = document.createElement("canvas");
        this.ctx = this.outCanvas.getContext('2d');
    }

    resize(w, h){
        this.outCanvas.width = w;
        this.outCanvas.height = h;
    }

    setPixelated(value){
        this.ctx['imageSmoothingEnabled'] = value;       
        this.ctx['mozImageSmoothingEnabled'] = value; 
        this.ctx['oImageSmoothingEnabled'] = value;    
        this.ctx['webkitImageSmoothingEnabled'] = value; 
        this.ctx['msImageSmoothingEnabled'] = value; 
    }

    render(entities){
        this.ctx.clearRect(0, 0, this.outCanvas.width, this.outCanvas.height);
        entities.forEach(e=>e.render(this.ctx));
    }
}

  